import * as React from "react";
import * as styles from "./ProgressBar.css";

export interface IProgressBarProps {
  backgroundColor: string,
  currentStep: number;
  totalSteps: number;
  isCompleted: boolean;
}

export interface IProgressBarState {
  percentageCompleted: number
  currentStep: number
}

export class ProgressBar extends React.Component<IProgressBarProps, IProgressBarState> {
  constructor(props: IProgressBarProps) {
    super(props);
    this.state = {
      currentStep: props.currentStep,
      percentageCompleted: props.isCompleted ? 100 : Math.ceil((100 / this.props.totalSteps) * (this.props.currentStep - 1))
    }
  }

  public componentDidUpdate(prevProps: IProgressBarProps): void {
    if (prevProps.currentStep !== this.props.currentStep || prevProps.isCompleted !== this.props.isCompleted) {
      this.setState({
        currentStep: this.props.currentStep,
        percentageCompleted: this.props.isCompleted ? 100 : Math.ceil((100 / this.props.totalSteps) * (this.props.currentStep - 1))
      });
    }
  }


  public render(): JSX.Element {
    let bar = (
      <div
        className={styles.IProgressBar_ContainerStyle}
      >
        <div
          className={styles.IProgressBar_FillerStyle}
          style={{
            width: `${this.state.percentageCompleted}%`,
            backgroundColor: '#333',
            transition: 'width .5s ease-in-out',
          }}
        >
          <span
            className={styles.IProgressBar_LabelStyle}
            style={{
              width: `${this.state.percentageCompleted}%`
            }}
          >
            {`${this.state.percentageCompleted}%`}
          </span>
        </div>
      </div>
    );

    return bar;
  }
}